import {Grid} from '@logistics-frontend/blocks'
import clsx from 'clsx'
import React from 'react'

import {useAccordion} from './Accordion'
import {classes} from './Accordion.classes'

type TProps = React.PropsWithChildren<{expandIcon?: React.ReactNode}>

export const AccordionSummary: React.FC<TProps> = ({children, expandIcon}) => {
  const {expanded, toggle} = useAccordion()

  return (
    <Grid alignItems="center" className={classes.summary} component="button" onClick={toggle} wrap="nowrap" container>
      {children}
      <div className={clsx(classes.expandIcon, expanded && classes.iconExpanded)}>{expandIcon ? expandIcon : null}</div>
    </Grid>
  )
}
